import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Field, reduxForm, getFormValues, isPristine } from "redux-form";
import { Row, Col, Input, Button, Select, message } from "antd";
import { FormBuilder } from "components/FormBuilder";
import {
  saveReportFields,
  showReportCustom,
  downloadCustom,
  showReport,
} from "../Module";
import moment from "moment-jalaali";
import { Menu, Popover, Tooltip } from "antd";
import MaterialIcon from "components/common/MaterialIcon";
import JsonExport from "../../../../../components/common/Table/JsonExport";
import axios from "axios";
import config from "config/api";
import store from "store";
@authorize
@reduxForm({
  form: "FormBuilder",
  onSubmit: (values, dispatch, props) => {
    let _values = values && values.values ? values.values : {};
    props.onClick(_values);
  },
})
@connect(
  (state) => ({
    currentUser: state.Auth.currentUser,
    values: getFormValues("FormBuilder")(state),
    dataReport: state.Attendance.Reports.dataReport,
    columnsCustom: state.Attendance.Reports.columnsCustom,
    dataReportCustom: state.Attendance.Reports.dataReportCustom,
    columns: state.Attendance.Reports.columns,
    properties: state.Attendance.Reports.properties,
  }),
  {
    saveReportFields,
    showReportCustom,
    downloadCustom,
    showReport,
  }
)
@autobind
/**
 *
 * @class ReportsForm
 * @extends PureComponent
 */
export default class ReportsForm extends React.PureComponent {
  static propTypes = {
    formFields: PropTypes.object,
    formValue: PropTypes.object,
    values: PropTypes.object,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    formFields: {},
    formValue: {},
    onClick: (input) => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      companyCode: localStorage.getItem("CompanyCode"),
    };
  }

  // Helper functions for Excel export
  pad = (n) => String(n).padStart(2, "0");

  parseHHMM = (t) => {
    if (!t || typeof t !== "string") return 0;
    const [h = "0", m = "0"] = t.split(":");
    const H = parseInt(h, 10) || 0;
    const M = parseInt(m, 10) || 0;
    return H * 60 + M;
  };

  minutesToHHMM = (mins) => {
    const H = Math.floor(mins / 60);
    const M = mins % 60;
    return `${this.pad(H)}:${this.pad(M)}`;
  };

  faJalali = (iso) => {
    try {
      const d = new Date(iso);
      return d.toLocaleDateString("fa-IR-u-ca-persian");
    } catch {
      return iso || "";
    }
  };

  componentDidMount() {
    this.props.initialize(
      this.props.formValue ? { values: this.props.formValue } : { values: {} }
    );
  }

  componentWillReceiveProps(np) {
    if (!app._.isEqual(np.form, this.props.form)) {
      if (np.formValue && !app._.isEqual(np.formValue, this.props.values)) {
        np.initialize(np.formValue ? { values: np.formValue } : { values: {} });
      }
    }
  }

  get _formFields() {
    let { formFields } = this.props;
    if (formFields.fields && Array.isArray(formFields.fields)) {
      formFields.fields.map((field) => {
        if (field.name === "positions") {
          field["permission"] = true;
          field["defaultValue"] =
            this.props.currentUser &&
            this.props.currentUser.positions &&
            !app._.isEmpty(this.props.currentUser.positions)
              ? this.props.currentUser.positions.pluck("id")
              : [];
        }
      });
    }
    return formFields;
  }

  _onSubmit = (e) => {
    const companyAvailability = localStorage.getItem("companyAvailability");

    if (companyAvailability === "20") {
      app.error("", "", "عدم موفقیت در تولید گزارش", "error");
      return;
    }

    const { submit, saveReportFields, formFields, values } = this.props;
    let _data = { form_fields: {} };

    let type_id = "";

    if (formFields.fields && Array.isArray(formFields.fields)) {
      formFields.fields.map((field) => {
        if (field.name === "types") {
          type_id = field.id;
        }
      });
    }
    if (type_id) {
      _data["form_fields"][type_id] =
        values && values.values && values.values.types;
      saveReportFields && saveReportFields(_data);
    }
    localStorage.setItem("reportsValues", JSON.stringify(values.values));

    submit && submit(e);
  };
  _DataSource(dataSource) {
    let data = [];
    dataSource.map((array) => {
      if (!app._.isEmpty(array.Body)) {
        data.push(...array.Body);
      }
    });
    return data;
  }

  /**
   * آماده‌سازی داده‌ها برای نمایش در جدول و صادرات به اکسل
   */
  prepareData(apiResponse) {
    console.log("API Response (prepareData):1", apiResponse);

    // بررسی ساختار داده ورودی
    // اگر داده در فرمت آرایه از آبجکت‌ها باشد (ساختار جدید)
    if (Array.isArray(apiResponse)) {
      return this.prepareDataFromNewFormat(apiResponse);
    }

    // ساختار قدیمی
    const root = apiResponse;

    if (!root) return { persons: [], dates: [], dateToDay: {} };

    // استخراج آیتم‌ها از بدنه
    const items = (root.payload || []).flatMap((p) => p.body || []);
    const personMap = new Map();

    // تاریخ‌های یکتا
    const dates = Array.from(
      new Set(items.map((i) => i?.payload?.date).filter(Boolean))
    ).sort();

    // نگاشت تاریخ -> نام روز
    const dateToDay = {};
    items.forEach((i) => {
      const p = i?.payload || {};
      if (p.date && p.day && !dateToDay[p.date]) dateToDay[p.date] = p.day;
    });

    // پردازش داده‌ها برای هر شخص
    for (const it of items) {
      const p = it?.payload || {};
      const personKey = `${p.personnel_id || ""}|${p.lastName || ""}|${
        p.firstName || ""
      }`;

      if (!personMap.has(personKey)) {
        personMap.set(personKey, {
          key: personKey,
          row_number: p.row_number ?? "",
          firstName: p.firstName ?? "",
          lastName: p.lastName ?? "",
          personnel_id: p.personnel_id ?? "",
          position: p.position ?? "",
          working_hour_name: p.working_hour_name ?? "",
          dates: {},
          totalActivity: 0,
          totalOvertime: 0,
          totalLeave: 0, // مجموع مرخصی
          totalClockIn: 0, // برای محاسبات احتمالی آینده
          totalClockOut: 0, // برای محاسبات احتمالی آینده
          totalShift: 0, // برای محاسبات احتمالی آینده
          onDuty: "",
        });
      }

      const person = personMap.get(personKey);

      if (p.date) {
        if (!person.dates[p.date]) {
          person.dates[p.date] = {};
        }

        // ذخیره داده‌های روز
        person.dates[p.date].shift = p.working_hour_name || p.shift || "";
        person.dates[p.date].clockIn = p.clock_in || "";
        person.dates[p.date].clockOut = p.clock_out || "";
        person.dates[p.date].activity = p.activity || "";
        person.dates[p.date].overtime = p.overtime || "";
        person.dates[p.date].leave = p.leave || "";

        // محاسبه جمع‌ها
        person.totalActivity += this.parseHHMM(p.activity);
        person.totalOvertime += this.parseHHMM(p.overtime);
        person.totalLeave += this.parseHHMM(p.leave || "00:00");

        // مقادیر شیفت، ورود و خروج معمولاً زمان نیستند، اما برای هماهنگی آنها را هم می‌شماریم
        if (p.working_hour_name || p.shift) person.totalShift++;
        if (p.clock_in) person.totalClockIn++;
        if (p.clock_out) person.totalClockOut++;
      }
    }
    console.log("rooroott", root);

    // تنظیم مقادیر خلاصه از footer
    const footerPayload = root?.payload?.[0]?.footer?.[0]?.payload || {};
    console.log("footerPayload:", footerPayload);

    const onDuty = footerPayload?.on_duty || "";
    const fraction = footerPayload?.fraction || "";
    const overtime = footerPayload?.overtime || "";

    // اعمال مقادیر خلاصه به هر شخص
    if (footerPayload) {
      personMap.forEach((person) => {
        person.onDuty = "11:11"; // موظفی هر ماه
        person.fraction = "11:11"; // کسر کار
        person.overtime = "11:11"; // استفاده از مقدار اضافه کار از footer یا مقدار محاسبه شده
      });
    }

    return {
      persons: Array.from(personMap.values()),
      dates,
      dateToDay,
    };
  }

  /**
   * پردازش ساختار داده جدید API
   * این تابع داده‌های دریافتی از API را در فرمت جدید پردازش می‌کند
   * @param {Array} dataArray - آرایه‌ای از داده‌های مربوط به کارمندان
   * @returns {Object} اطلاعات کارمندان، تاریخ‌ها و روزهای هفته
   */
  prepareDataFromNewFormat(dataArray) {
    if (!dataArray || !dataArray.length)
      return { persons: [], dates: [], dateToDay: {} };

    const personMap = new Map();

    // جمع‌آوری تمام تاریخ‌ها
    const allDates = new Set();
    const dateToDay = {};

    // ابتدا همه تاریخ‌ها را جمع‌آوری می‌کنیم
    dataArray.forEach((section) => {
      if (!section.body || !section.body.length) return;

      section.body.forEach((row) => {
        if (!row._props || !row._props.type) {
          if (row.date) {
            allDates.add(row.date);
            if (row.day) dateToDay[row.date] = row.day;
          }
        }
      });
    });

    // پردازش هر مجموعه داده برای استخراج اطلاعات کارمندان
    dataArray.forEach((section) => {
      if (!section.body || !section.body.length) return;

      // یافتن مقادیر پیش‌فرض از footer
      let footerData = {
        onDuty: "00:00",
        fraction: "00:00",
        overtime: "00:00",
        activity: "00:00",
      };

      // یافتن footer مربوط به این بخش در section.body
      const sectionFooter = section.body.find(
        (item) => item._props && item._props.type === "footer"
      );
      if (sectionFooter) {
        footerData.onDuty = sectionFooter.onDuty || footerData.onDuty;
        footerData.fraction = sectionFooter.fraction || footerData.fraction;
        footerData.overtime = sectionFooter.overtime || footerData.overtime;
        footerData.activity = sectionFooter.activity || footerData.activity;
      }

      // جمع‌آوری اطلاعات کارمند از props
      let personnelInfo = {};
      if (section.props && section.props.user && section.props.user.profile) {
        const profile = section.props.user.profile;
        personnelInfo = {
          personnelId: profile.personnelId || "",
          firstName: profile.firstName || "",
          lastName: profile.lastName || "",
        };
      }

      // پردازش هر رکورد در بدنه (به جز footer)
      const dataRows = section.body.filter(
        (row) => !row._props || !row._props.type
      );

      dataRows.forEach((row) => {
        // کلید یکتا برای هر شخص - اولویت با داده‌های سطر فعلی، سپس اطلاعات از props
        const personKey = `${
          row.personnelId || personnelInfo.personnelId || ""
        }|${row.lastName || personnelInfo.lastName || ""}|${
          row.firstName || personnelInfo.firstName || ""
        }`;

        if (!personMap.has(personKey)) {
          // ایجاد رکورد جدید برای کارمند
          personMap.set(personKey, {
            key: personKey,
            row_number: row.rowNumber || "",
            firstName: row.firstName || personnelInfo.firstName || "",
            lastName: row.lastName || personnelInfo.lastName || "",
            personnel_id: row.personnelId || personnelInfo.personnelId || "",
            position: row.position || "",
            working_hour_name: row.workingHourName || "",
            dates: {},
            totalActivity: 0,
            totalOvertime: 0,
            totalLeave: 0,
            totalClockIn: 0,
            totalClockOut: 0,
            totalShift: 0,
            onDuty: "00:00", // مقدار اولیه، بعداً از footer به‌روزرسانی می‌شود
            fraction: "00:00", // مقدار اولیه، بعداً از footer به‌روزرسانی می‌شود
          });
        }

        const person = personMap.get(personKey);

        // پردازش داده‌های روز
        if (row.date) {
          if (!person.dates[row.date]) {
            person.dates[row.date] = {};
          }

          // ترکیب زمان‌های ورود و خروج چندگانه
          const clockIn = [row.clockIn1, row.clockIn2, row.clockIn3]
            .filter(Boolean)
            .join(" - ");
          const clockOut = [row.clockOut1, row.clockOut2, row.clockOut3]
            .filter(Boolean)
            .join(" - ");

          // ذخیره داده‌های روز
          person.dates[row.date].shift = row.workingHourName || "";
          person.dates[row.date].clockIn = clockIn;
          person.dates[row.date].clockOut = clockOut;
          person.dates[row.date].activity = row.activity || "00:00";
          person.dates[row.date].overtime = row.overtime || "00:00";
          person.dates[row.date].leave = row.hourlyLeave || "00:00";

          // محاسبه جمع‌ها
          person.totalActivity += this.parseHHMM(row.activity || "00:00");
          person.totalOvertime += this.parseHHMM(row.overtime || "00:00");
          person.totalLeave += this.parseHHMM(row.hourlyLeave || "00:00");

          // شمارش تعداد برای سایر فیلدها
          if (row.workingHourName) person.totalShift++;
          if (clockIn) person.totalClockIn++;
          if (clockOut) person.totalClockOut++;
        }
      });

      // بررسی اطلاعات footerItems برای مقادیر خلاصه
      if (section.footerItems && section.footerItems.length) {
        // یافتن footer مناسب با کلید متناظر با آخرین آیتم body
        const lastDataRow = dataRows[dataRows.length - 1];
        const lastKey = lastDataRow?.key;

        // ابتدا سعی می‌کنیم footer با کلید مشابه را پیدا کنیم
        let matchingFooter = section.footerItems.find(
          (f) =>
            f.key === (lastKey ? Number(lastKey) + 1 : undefined)?.toString()
        );

        // اگر پیدا نشد، از اولین footer استفاده می‌کنیم
        if (!matchingFooter && section.footerItems.length > 0) {
          matchingFooter = section.footerItems.find(
            (f) =>
              f._props?.type === "footer" &&
              (f.onDuty || f.fraction || f.activity)
          );
        }

        if (matchingFooter) {
          console.log("matchingFooter found:", matchingFooter);

          // دریافت مقادیر از payload یا در صورت عدم وجود استفاده از مقدار پیش‌فرض "00:00"
          const footerOnDuty =
            matchingFooter.payload?.on_duty || matchingFooter.onDuty || "00:00";
          const footerFraction =
            matchingFooter.payload?.fraction ||
            matchingFooter.fraction ||
            "00:00";

          // به‌روزرسانی مقادیر برای همه افراد در این بخش
          dataRows.forEach((row) => {
            const personKey = `${
              row.personnelId || personnelInfo.personnelId || ""
            }|${row.lastName || personnelInfo.lastName || ""}|${
              row.firstName || personnelInfo.firstName || ""
            }`;

            if (personMap.has(personKey)) {
              const person = personMap.get(personKey);
              // استفاده از مقادیر footer به جای مقادیر از body
              person.onDuty = footerOnDuty;
              person.fraction = footerFraction;
            }
          });
        }
      }
    });

    // اطمینان از اینکه همه کارمندان مقادیر معتبری برای onDuty و fraction دارند
    personMap.forEach((person) => {
      // اگر هنوز onDuty وجود نداشت یا "00:00" بود، استفاده از مقدار پیش‌فرض
      if (!person.onDuty || person.onDuty === "") {
        person.onDuty = "00:00";
      }

      // اگر هنوز fraction وجود نداشت یا "00:00" بود، استفاده از مقدار پیش‌فرض
      if (!person.fraction || person.fraction === "") {
        person.fraction = "00:00";
      }
    });

    return {
      persons: Array.from(personMap.values()),
      dates: Array.from(allDates).sort(),
      dateToDay,
    };
  }
  /**
   * صادرات به فایل اکسل با استفاده از HTML
   */
  /**
   * صادرات به فایل اکسل با استفاده از HTML
   */
  exportToExcel() {
    try {
      const { title, dataReportCustom, dataReport, item } = this.props;
      console.log("Exporting to Excel...", dataReport);

      const exportTitle = title || "گزارش حضور و غیاب";

      // بررسی اینکه از کدام داده استفاده کنیم
      const useDataReport = item && item.id === 212;

      // انتخاب داده‌ها براساس نوع گزارش
      const dataToProcess = useDataReport
        ? dataReport
        : Array.isArray(dataReportCustom)
        ? dataReportCustom
        : dataReportCustom || {};

      // دریافت داده‌ها با فرمت جدید
      const { persons, dates, dateToDay } = this.prepareData(dataToProcess);

      // بررسی داده‌ها
      if (!dates || dates.length === 0) {
        message.error("لطفا حداقل یک کاربر انتخاب شود.");
        console.error("No dates found in data");
        return;
      }

      if (!persons || persons.length === 0) {
        message.error("خطا: داده‌های پرسنلی پیدا نشدند");
        console.error("No person data found");
        return;
      }

      console.log("Processing export with dates:", dates);
      console.log("Day names:", dateToDay);

      // تعریف انواع کارکرد
      const activityTypes = [
        { key: "shift", title: "شیفت" },
        { key: "clockIn", title: "ورود" },
        { key: "clockOut", title: "خروج" },
        { key: "activity", title: "کارکرد" },
        { key: "overtime", title: "اضافه کار" },
        { key: "leave", title: "مرخصی" },
      ];

      // ایجاد HTML با استایل مناسب برای اکسل
      let html = `
        <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
        <head>
          <meta charset="UTF-8">
          <!--[if gte mso 9]>
          <xml>
            <x:ExcelWorkbook>
              <x:ExcelWorksheets>
                <x:ExcelWorksheet>
                  <x:Name>${exportTitle}</x:Name>
                  <x:WorksheetOptions>
                    <x:DisplayRightToLeft/>
                  </x:WorksheetOptions>
                </x:ExcelWorksheet>
              </x:ExcelWorksheets>
            </x:ExcelWorkbook>
          </xml>
          <![endif]-->
          <style>
            table, td, th {
              border: 1px solid #999999;
              border-collapse: collapse;
              font-family: Tahoma, Arial, sans-serif;
            }
            th {
              background-color: #E6F7FF;
              color: black;
              font-weight: bold;
              text-align: center;
              padding: 5px;
              height: 30px;
            }
            td {
              padding: 5px;
              text-align: center;
              height: 25px;
            }
            tr:nth-child(even) {
              background-color: #FFFFFF;
            }
            tr:nth-child(odd) {
              background-color: #F9F9F9;
            }
            .weekend {
              background-color: #FFCCCC !important;
            }
            .title {
              font-size: 14pt;
              font-weight: bold;
              text-align: center;
              padding: 10px;
              height: 35px;
              background-color: #E6F7FF;
              color: black;
              border: 1px solid #999999;
            }
            .info-row {
              background-color: #FFFFFF;
            }
            .separator-row {
              height: 5px;
              background-color: #CCCCCC;
              border-top: 2px solid #666666;
              border-bottom: 2px solid #666666;
            }
            .person-header {
              font-weight: bold;
              background-color: #f0f0f0;
            }
          </style>
        </head>
        <body dir="rtl">
          <table>
            <thead>
              <tr>
                <th rowspan="2">ردیف</th>
                <th rowspan="2">نام</th>
                <th rowspan="2">نام خانوادگی</th>
                <th rowspan="2">شماره پرسنلی</th>
                <th rowspan="2">مرکز فعالیت</th>
                <th rowspan="2">نوع کارکرد</th>
      `;

      // هدر روزها
      dates.forEach((date) => {
        const dayName = dateToDay[date] || "";
        const isWeekend = dayName === "جمعه";
        html += `<th ${isWeekend ? 'class="weekend"' : ""}>${dayName}</th>`;
      });

      // هدرهای مجموع
      html += `
                <th rowspan="2">مجموع هر سطر</th>
                <th rowspan="2">موظفی هر ماه</th>
                <th rowspan="2">کسر کار</th>
              </tr>
              <tr>
      `;

      // سطر دوم هدر (تاریخ‌ها)
      dates.forEach((date) => {
        const dayName = dateToDay[date] || "";
        const isWeekend = dayName === "جمعه";
        html += `<th ${isWeekend ? 'class="weekend"' : ""}>${this.faJalali(
          date
        )}</th>`;
      });

      html += `
              </tr>
            </thead>
            <tbody>
      `;

      // داده‌های اصلی
      persons.forEach((person, personIndex) => {
        // تعداد ردیف برای هر شخص (تعداد انواع کارکرد)
        const rowspanCount = activityTypes.length;
        console.log("Person data:", person);

        // اگر این فرد اول نیست، یک ردیف جدا کننده اضافه کن
        if (personIndex > 0) {
          // تعداد کل ستون‌ها: 6 (ستون‌های ثابت) + تعداد روزها + 3 (ستون‌های مجموع و موظفی و کسر کار)
          const totalColumns = 6 + dates.length + 3;

          // افزودن یک ردیف خالی با خط پررنگ به عنوان جداکننده بین افراد
          html += `<tr style="height: 5px; background-color: #CCCCCC;"><td colspan="${totalColumns}" style="padding: 0; border-top: 2px solid #666666; border-bottom: 2px solid #666666;"></td></tr>`;
        }

        activityTypes.forEach((activityType, activityIndex) => {
          html += "<tr>";

          // اطلاعات شخص با rowspan در اولین نوع کارکرد
          if (activityIndex === 0) {
            // ستون‌های مشترک با rowspan
            html += `<td rowspan="${rowspanCount}" style="vertical-align: middle; font-weight: bold;">${
              person.row_number || ""
            }</td>`;
            html += `<td rowspan="${rowspanCount}" style="vertical-align: middle; font-weight: bold;">${
              person.firstName || ""
            }</td>`;
            html += `<td rowspan="${rowspanCount}" style="vertical-align: middle; font-weight: bold;">${
              person.lastName || ""
            }</td>`;
            html += `<td rowspan="${rowspanCount}" style="vertical-align: middle;">${
              person.personnel_id || ""
            }</td>`;
            html += `<td rowspan="${rowspanCount}" style="vertical-align: middle;">${
              person.position || ""
            }</td>`;
          }

          // ستون نوع کارکرد همیشه نمایش داده می‌شود
          html += `<td>${activityType.title}</td>`;

          // داده‌های روزها
          dates.forEach((date) => {
            const dayData = person.dates[date] || {};
            const dayName = dateToDay[date] || "";
            const isWeekend = dayName === "جمعه";
            const value = dayData[activityType.key] || "-";

            html += `<td ${isWeekend ? 'class="weekend"' : ""}>${value}</td>`;
          });

          // محاسبه مجموع ساعت‌های معتبر برای این نوع کارکرد
          let totalMinutes = 0;
          dates.forEach((date) => {
            const dayData = person.dates[date] || {};
            const value = dayData[activityType.key] || "-";
            // فقط اگر مقدار به فرمت ساعت باشد و خط تیره نباشد
            if (
              typeof value === "string" &&
              value !== "-" &&
              /^\d{1,2}:\d{2}$/.test(value)
            ) {
              totalMinutes += this.parseHHMM(value);
            }
          });
          html += `<td>${
            totalMinutes > 0 ? this.minutesToHHMM(totalMinutes) : ""
          }</td>`;
          // ستون‌های موظفی و کسر کار فقط برای سطرهای خاص
          if (activityType.key === "overtime") {
            html += `<td>${person.onDuty || ""}</td>`;
            html += "<td></td>";
          } else if (activityType.key === "shift") {
            html += "<td></td>";
            html += `<td>${person.fraction || ""}</td>`;
          } else {
            html += "<td></td><td></td>";
          }

          html += "</tr>";
        });
      });

      html += `
            </tbody>
          </table>
        </body>
        </html>
      `;

      // تبدیل HTML به بلاب
      const blob = new Blob(["\uFEFF" + html], {
        type: "application/vnd.ms-excel;charset=utf-8",
      });

      // دانلود فایل
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        `${exportTitle}_${new Date()
          .toLocaleDateString("fa-IR")
          .replace(/\//g, "-")}.xls`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      message.success("فایل اکسل با موفقیت دانلود شد.");
    } catch (error) {
      console.error("خطا در صادرات به فایل اکسل:", error);
      message.error("خطا در صادرات به فایل اکسل. لطفاً مجدداً تلاش کنید.");
    }
  }

  componentDidUpdate(prevProps) {
    const {
      showReportCustom,
      columnsCustom,
      values,
      formValue,
      dataReport,
      columns,
      properties,
      title,
      dataReportCustom,
      item,
    } = this.props;

    // حذف فراخوانی خودکار exportToExcel برای جلوگیری از دانلود دوبار
    // فراخوانی از طریق کالبک showReport در _onSubmitExcel انجام می‌شود

    const url = config.url.replace(/\/v1$/, ""); // حذف /v1 از انتهای URL

    console.log("componentDidUpdate - columnsCustom:", columnsCustom);

    let _dataSource = this._DataSource(dataReportCustom);
    console.log("_dataSourc_dataSourcee", _dataSource);
    console.log("_dataSourc_dataSourcee", columnsCustom?.columns);

    // اگر dataTable در columnsCustom ظاهر شد و قبلاً وجود نداشت، فایل را باز کنید
    if (
      columnsCustom?.dataTable &&
      (!prevProps.columnsCustom ||
        !prevProps.columnsCustom.dataTable ||
        prevProps.columnsCustom.dataTable !== columnsCustom.dataTable)
    ) {
      console.log("New dataTable detected:", columnsCustom.dataTable);
      this.setState({ loading: false });
      let exporter = new JsonExport(
        _dataSource,
        columnsCustom?.columns
        // dataExport,
        // columns,
        // selectedColumns,
        // footerItems
      );

      exporter.exportAs("excel", "export");
      // باز کردن فایل در پنجره جدید
      try {
        const fullUrl = `http://${url}${columnsCustom.dataTable}`;
        console.log("Opening URL:", fullUrl);
        window.open(fullUrl, "_blank");
      } catch (error) {
        console.error("Error opening URL:", error);
        // app.error("خطا در باز کردن فایل اکسل");
      }
    }
  }
  _onSubmitExcel = async () => {
    const {
      showReportCustom,
      showReport,
      values,
      dataReportCustom,
      dataReport,
      columnsCustom,
      item,
    } = this.props;
    this.setState({ loading: true });

    if (item && item.id === 212) {
      // Use showReport for item.id === 212
      const params = values.values || {};

      // Add timestamp to prevent caching
      params._t = new Date().getTime();

      console.log("Calling showReport with params:", params);

      showReport(item.id, params, (err, data) => {
        console.log(
          "showReport callback executed, dataReport:",
          this.props.dataReport,
          data
        );
        this.setState({ loading: false });

        if (err) {
          console.error("Error in showReport:", err);
          // app.error("خطا در دریافت اطلاعات از سرور");
          return;
        }

        // Allow data to be fully loaded in Redux store
        setTimeout(() => {
          try {
            // We'll use dataReport instead of dataReportCustom
            if (this.props.dataReport) {
              this.exportToExcel();
            } else {
              // app.error("داده‌ای برای تولید گزارش یافت نشد");
              console.error("No data found for export");
            }
          } catch (error) {
            console.error("Error exporting to Excel:", error);
            // app.error("خطا در تولید فایل اکسل");
          }
        }, 500);
      });
      return;
    }

    // فقط درخواست را ارسال می‌کنیم و بقیه کارها را به componentDidUpdate واگذار می‌کنیم
    showReportCustom(values.values,item.id, (err, result) => {
      if (err) {
        // console.error("Error in showReportCustom callback:", err);
        this.setState({ loading: false });
        // app.error("خطا در دریافت اطلاعات از سرور");
      }
      console.log("Result from showReportCustom:", result);

      // به‌روزرسانی loading را به componentDidUpdate واگذار می‌کنیم
      // چون ممکن است dataTable بلافاصله در دسترس نباشد
    });
  };

  _export() {
    const { onExport, haveCustomExport, columns, columnsCustom } = this.props;
    console.log("columnsCustom", columnsCustom?.columns);

    let content = (
      <Menu onClick={onExport}>
        <Menu.Item key="csv">
          <MaterialIcon size="tiny" name="file-delimited" />
          CSV
        </Menu.Item>
      </Menu>
    );
    return (
      <Button>
        <Menu>
          <Menu.Item key="csv">
            <MaterialIcon size="tiny" name="file-delimited" />
            CSV
          </Menu.Item>
        </Menu>
      </Button>
    );
  }
  /**
   *
   * @return {XML}
   */
  render() {
    const { formValue, item, submit, title, dataReport, columns, properties } =
      this.props;
    const { loading } = this.state;
    console.log("formValufitem", formValue);
    console.log("formValufitem", item);

    return (
      <div
        style={{
          height: "100%",
        }}
      >
        <div
          style={{
            height: "calc(100% - 40px)",
            overflow: "auto",
            marginBottom: "9px",
          }}
        >
          <Row
            style={{
              height: "100%",
            }}
          >
            <FormBuilder
              formFields={this._formFields}
              md={24}
              formValues={this.props.values}
              componentName={"Report"}
              goMonthLater={true}
            />
          </Row>
        </div>
        <div style={{ display: "flex", gap: "4px" }}>
          {title !== "گزارش شهرداری اهواز" && item.id !== 212 && (
            <Button type="primary" onClick={this._onSubmit}>
              {app.translate(
                "routes.home.attendance.reports.Get Report",
                "Get Report"
              )}
            </Button>
          )}
          {(title === "گزارش شهرداری اهواز" ||
            item.id == 212 ||
            item.id == 93 ||
            item.id == 214 ||
            (this.state.companyCode == "15708" && item.id == 94)) && (
            //  || title === "5گزارش مجموع"
            <Button
              type="secondary"
              onClick={this._onSubmitExcel}
              loading={loading}
            >
              {app.translate("دریافت فایل اکسل")}
            </Button>
          )}
          {/* {this._export()} */}
        </div>
      </div>
    );
  }
}

// import React from "react";
// import PropTypes from "prop-types";
// import { connect } from "react-redux";
// import { Field, reduxForm, getFormValues, isPristine } from "redux-form";
// import { Row, Col, Input, Button, Select } from "antd";
// import { FormBuilder } from "components/FormBuilder";
// import { saveReportFields, showReportCustom } from "../Module";
// import moment from "moment-jalaali";
// import { Menu, Popover, Tooltip } from "antd";
// import MaterialIcon from "components/common/MaterialIcon";
// import JsonExport from "../../../../../components/common/Table/JsonExport";

// @authorize
// @reduxForm({
//   form: "FormBuilder",
//   onSubmit: (values, dispatch, props) => {
//     let _values = values && values.values ? values.values : {};
//     props.onClick(_values);
//   },
// })
// @connect(
//   (state) => ({
//     currentUser: state.Auth.currentUser,
//     values: getFormValues("FormBuilder")(state),
//     dataReport: state.Attendance.Reports.dataReport,
//     columnsCustom: state.Attendance.Reports.columnsCustom,
//     dataReportCustom: state.Attendance.Reports.dataReportCustom,
//     columns: state.Attendance.Reports.columns,
//     properties: state.Attendance.Reports.properties,
//   }),
//   {
//     saveReportFields,
//     showReportCustom,
//   }
// )
// @autobind
// /**
//  *
//  * @class ReportsForm
//  * @extends PureComponent
//  */
// export default class ReportsForm extends React.PureComponent {
//   static propTypes = {
//     formFields: PropTypes.object,
//     formValue: PropTypes.object,
//     values: PropTypes.object,
//     onClick: PropTypes.func,
//   };

//   static defaultProps = {
//     formFields: {},
//     formValue: {},
//     onClick: (input) => {},
//   };

//   constructor(props) {
//     super(props);
//     this.state = {
//       companyCode: localStorage.getItem("CompanyCode"),
//     };
//   }

//   componentDidMount() {
//     this.props.initialize(
//       this.props.formValue ? { values: this.props.formValue } : { values: {} }
//     );
//   }

//   componentWillReceiveProps(np) {
//     if (!app._.isEqual(np.form, this.props.form)) {
//       if (np.formValue && !app._.isEqual(np.formValue, this.props.values)) {
//         np.initialize(np.formValue ? { values: np.formValue } : { values: {} });
//       }
//     }
//   }

//   get _formFields() {
//     let { formFields } = this.props;
//     if (formFields.fields && Array.isArray(formFields.fields)) {
//       formFields.fields.map((field) => {
//         if (field.name === "positions") {
//           field["permission"] = true;
//           field["defaultValue"] =
//             this.props.currentUser &&
//             this.props.currentUser.positions &&
//             !app._.isEmpty(this.props.currentUser.positions)
//               ? this.props.currentUser.positions.pluck("id")
//               : [];
//         }
//       });
//     }
//     return formFields;
//   }

//   _onSubmit = (e) => {
//     const { submit, saveReportFields, formFields, values } = this.props;
//     let _data = { form_fields: {} };

//     let type_id = "";

//     if (formFields.fields && Array.isArray(formFields.fields)) {
//       formFields.fields.map((field) => {
//         if (field.name === "types") {
//           type_id = field.id;
//         }
//       });
//     }
//     if (type_id) {
//       _data["form_fields"][type_id] =
//         values && values.values && values.values.types;
//       saveReportFields && saveReportFields(_data);
//     }

//     submit && submit(e);
//   };
//   _DataSource(dataSource) {
//     console.log("dataSourcdataSourcee",dataSource);

//     let data = [];
//     dataSource?.map((array) => {
//       if (!app._.isEmpty(array.Body)) {
//         data.push(...array.Body);
//       }
//     });

//     return data;
//   }
//   componentDidUpdate(prevProps) {
//     const {
//       showReportCustom,
//       columnsCustom,
//       values,
//       formValue,
//       dataReport,
//       columns,
//       properties,title,
//       dataReportCustom,
//     } = this.props;
//     console.log("columnsSafaDashcolumnsSafaDashcolumnsCustomtt", dataReportCustom);

//     if (
//       prevProps.columnsCustom !== columnsCustom
//     ) {
//       let _dataSource = this._DataSource(dataReportCustom);
//      console.log("_dataSourc_dataSourcee",_dataSource);
//      console.log("_dataSourc_dataSourcee",columnsCustom?.columns);

//       let exporter = new JsonExport(
//         _dataSource,
//         columnsCustom?.columns
//         // dataExport,
//         // columns,
//         // selectedColumns,
//         // footerItems
//       );

//       exporter.exportAs("excel", "export");
//     }
//   }
//   _onSubmitExcel = async (base64Data) => {
//     const {
//       showReportCustom,
//       columnsCustom,
//       values,
//       formValue,
//       dataReport,
//       columns,
//       properties,
//       dataReportCustom,
//     } = this.props;

//     await showReportCustom(values.values);
//     let _dataSource = this._DataSource(dataReportCustom);
//   };

//   _export() {
//     const { onExport, haveCustomExport, columns, columnsCustom } = this.props;
//     console.log("columnsCustom", columnsCustom?.columns);

//     let content = (
//       <Menu onClick={onExport}>
//         <Menu.Item key="csv">
//           <MaterialIcon size="tiny" name="file-delimited" />
//           CSV
//         </Menu.Item>
//       </Menu>
//     );
//     return (
//       <Button>
//         <Menu>
//           <Menu.Item key="csv">
//             <MaterialIcon size="tiny" name="file-delimited" />
//             CSV
//           </Menu.Item>
//         </Menu>
//       </Button>
//     );
//   }
//   /**
//    *
//    * @return {XML}
//    */
//   render() {
//     const { submit, title, dataReport, columns, properties } = this.props;

//     return (
//       <div
//         style={{
//           height: "100%",
//         }}
//       >
//         <div
//           style={{
//             height: "calc(100% - 40px)",
//             overflow: "auto",
//             marginBottom: "9px",
//           }}
//         >
//           <Row
//             style={{
//               height: "100%",
//             }}
//           >
//             <FormBuilder
//               formFields={this._formFields}
//               md={24}
//               formValues={this.props.values}
//               componentName={"Report"}
//               goMonthLater={true}
//             />
//           </Row>
//         </div>
//         <div style={{ display: "flex", gap: "4px" }}>
//           {title !== "گزارش شهرداری اهواز" && (
//             <Button type="primary" onClick={this._onSubmit}>
//               {app.translate(
//                 "routes.home.attendance.reports.Get Report",
//                 "Get Report"
//               )}
//             </Button>
//           )}
//           {true&& (
//             <Button type="secondary" onClick={this._onSubmitExcel}>
//               {app.translate("دریافت فایل اکسل")}
//             </Button>
//           )}
//           {/* {this._export()} */}
//         </div>
//       </div>
//     );
//   }
// }
